import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Datenschutz() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-white min-h-screen">
      <div className="container px-4 mx-auto md:px-8 max-w-4xl">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-emerald lg:prose-lg max-w-none"
        >
          <h1 className="text-4xl font-bold text-emerald-950 mb-8 border-b pb-4">Datenschutzerklärung</h1>
          
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-emerald-900 mb-6">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-xl font-bold text-emerald-800 mb-4">Allgemeine Hinweise</h3>
            <p className="text-gray-700 leading-relaxed">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>

            <h3 className="text-xl font-bold text-emerald-800 mt-8 mb-4">Datenerfassung auf dieser Website</h3>
            <div className="space-y-6 text-gray-700">
              <div>
                <h4 className="font-bold text-emerald-950">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</h4>
                <p>Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in dieser Datenschutzerklärung entnehmen.</p>
              </div>
              <div>
                <h4 className="font-bold text-emerald-950">Wie erfassen wir Ihre Daten?</h4>
                <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).</p>
              </div>
              <div>
                <h4 className="font-bold text-emerald-950">Wofür nutzen wir Ihre Daten?</h4>
                <p>Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-emerald-900 mb-6">2. Hosting</h2>
            <p className="text-gray-700 mb-4">Wir hosten die Inhalte unserer Website bei folgendem Anbieter:</p>
            <div className="p-6 bg-gray-50 border border-gray-100 rounded-sm mb-6">
              <h3 className="text-lg font-bold text-emerald-900 mb-2">Externes Hosting</h3>
              <p className="text-gray-700">
                Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert.<br /><br />
                <strong>Netlify, Inc.</strong><br />
                44 Montgomery Street, Suite 300<br />
                San Francisco, CA 94104, USA
              </p>
            </div>
            <h4 className="font-bold text-emerald-950 mb-2">Auftragsverarbeitung</h4>
            <p className="text-gray-700">Wir haben einen Vertrag über Auftragsverarbeitung (AVV) zur Nutzung des oben genannten Dienstes geschlossen. Dies gewährleistet, dass der Dienstleister Ihre Daten nur nach unseren Weisungen und unter Einhaltung der DSGVO verarbeitet.</p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-emerald-900 mb-6">3. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3 className="text-xl font-bold text-emerald-800 mb-4">Hinweis zur verantwortlichen Stelle</h3>
            <div className="p-6 bg-emerald-50/50 border-l-4 border-emerald-900 rounded-sm">
              <p className="text-gray-800">
                <strong>Familie Küppers</strong><br />
                Dipl.-Ing. Horst Küppers<br />
                Waldhufenstr. 9<br />
                52525 Heinsberg<br /><br />
                Telefon: 02452 - 9963733<br />
                E-Mail: <a href="mailto:hkp@kueppers.biz" className="text-emerald-700 hover:underline">hkp@kueppers.biz</a>
              </p>
            </div>
            
            <h3 className="text-xl font-bold text-emerald-800 mt-8 mb-4">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="text-gray-700">Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.</p>
            
            <h3 className="text-xl font-bold text-emerald-800 mt-8 mb-4">SSL- bzw. TLS-Verschlüsselung</h3>
            <p className="text-gray-700">Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf „https://“ wechselt.</p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-emerald-900 mb-6">4. Datenerfassung auf dieser Website</h2>
            <h3 className="text-xl font-bold text-emerald-800 mb-4">Cookies</h3>
            <p className="text-gray-700 mb-4">Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.</p>
            
            <h3 className="text-xl font-bold text-emerald-800 mt-8 mb-4">Kontaktformular</h3>
            <p className="text-gray-700">Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-emerald-900 mb-6">5. eCommerce und Zahlungsanbieter</h2>
            <h3 className="text-xl font-bold text-emerald-800 mb-4">Verarbeiten von Kunden- und Vertragsdaten</h3>
            <p className="text-gray-700">Wir erheben, verarbeiten und nutzen personenbezogene Kunden- und Vertragsdaten zur Begründung, inhaltlichen Ausgestaltung und Änderung unserer Vertragsbeziehungen. Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO.</p>
          </section>
        </motion.div>
      </div>
    </div>
  );
}